import React, { useCallback, useEffect, useRef } from 'react'
import { IPostMessage, PostMessageTypes, routeUtils, UdModal } from '@ud/admin-framework'
import { appStore } from '../../stores'
import { uaaCenter } from '../../uaaCenter'
import { getSystemMenu } from '../../utils/old-menu'
import SelectDepartment from './components/SelectDepartment'
import SelectJobs from './components/SelectJobs'
import SelectPerson from './components/SelectPerson'
import SelectSuperiorLeader from './components/SelectSuperiorLeader'
import { activeWatcher } from '../../utils'

const useMessageHandler = ({ enable = true, onChangeUrl: changeIframeUrl }: IUseMessageHandlerOptions) => {

  const commands = useRef<MessageHandlers>({
    'OriginLoginInfo': (req, source, origin) => {
      let res = {
        type: req.type,
        data: {
          systemInfo: appStore.myUserData,
          urls: appStore.myUserData.urls,
          systemSelectKey: appStore.currentSystemCode,
          Authorization: appStore.getToken()
        }
      }
      //@ts-ignore ts版本太低，内置类型有误，导致无法编译通过，但实际ts会导致和其他库不兼容也编译不通过（此问题有解，但限于时间未去解决）
      source.postMessage(res, { targetOrigin: origin })
    },
    'GetLoginInfo': (req, source, origin) => {
      let res = {
        type: 'GetLoginInfo',
        data: {
          ...appStore.myUserData,
          token: appStore.getToken()
        }
      }
      //@ts-ignore ts版本太低，内置类型有误，导致无法编译通过，但实际ts会导致和其他库不兼容也编译不通过（此问题有解，但限于时间未去解决）
      source.postMessage(res, { targetOrigin: origin })
    },
    'RefreshToken': (req, source, origin) => {
      uaaCenter.refreshToken((data) => {
        //@ts-ignore
        source.postMessage({ type: req.type, data }, { targetOrigin: origin })
      })
    },
    'ChangeUrl': (req, source, origin) => {
      uaaCenter.setLastVisitUrl(req.data)
    },
    'Logout': () => {
      appStore.logout()
    },
    'ParentShow': (req, source, origin) => {
      if (typeof req.data == 'string') {
        req.data = req.data === 'true' ? true : false
      }
      appStore.showCenterHeader = req.data
      appStore.showCenterSidebar = req.data
      let data = {
        ParentShow: req.data,
        dec: req.data ? '管理中心显示' : '管理中心隐藏'
      }
      //@ts-ignore
      source.postMessage({ type: 'ParentShow', data }, { targetOrigin: origin })
    },
    'LoginInfo': (req, source, origin) => {
      console.warn('[PostMessage] 请不要再使用此消息，后续版本将被删除！', req, origin)
      let { menus, pageKeyObject, btnlist } = getSystemMenu(appStore.myUserData.generalMenus, '')
      console.log(menus,'---',appStore.myUserData.generalMenus)
      let res = {
        type: req.type,
        data: {
          systemInfo: {
            menus,
            pageKeyObject,
            btnlist,
            userInfo: appStore.myUserData.profile,
            authorities: appStore.myUserData.authorities,
            webUrls: appStore.myUserData.webUrls
          },
          urls: appStore.myUserData.urls,
          systemSelectKey: appStore.currentSystemCode,
          Authorization: appStore.getToken()
        }
      }    
      //@ts-ignore
      source.postMessage(res, { targetOrigin: origin })
    },
    'openModal': (req, source, origin) => {
      let modalContent: any = null
      const receiveData = req.data
      return new Promise<void>((resolve, reject) => {
        if (receiveData.contentType === 'person') {
          modalContent = (
            <SelectPerson receiveData={receiveData} />
          )
        } else if (receiveData.contentType === 'jobs') {
          modalContent = (
            <SelectJobs receiveData={receiveData} />
          )
        } else if (receiveData.contentType === 'department') {
          modalContent = (
            <SelectDepartment receiveData={receiveData} />
          )
        } else if (receiveData.contentType === 'superiorLeader') {
          modalContent = (
            <SelectSuperiorLeader currentUser={receiveData.data} />
          )
        }
        resolve()
      }).then(() => {
        UdModal.open({
          title: receiveData.modalTitle,
          content: modalContent,
          width: '1200px',
          onOk: (value) => {
            const data = { status: 'success', values: value }
            //@ts-ignore
            source.postMessage({ type: req.type, data }, { targetOrigin: origin })
          },
          onCancel: () => {
            const data = { status: 'fail' }
            //@ts-ignore
            source.postMessage({ type: req.type, data }, { targetOrigin: origin })
          }
        })
      })
    },
    'OpenOtherSubSystemPage': (req, source, origin) => {
      const reqData = req.data || {}
      const { code: openSystemCode, path, ...others } = reqData
      const subSysBaseUrl = appStore.myUserData.webUrls[openSystemCode]
      if (!(openSystemCode && subSysBaseUrl)) {
        return console.error('[PostMessage] 要打开子系统 code 有误', openSystemCode)
      }
      const urlParams = { path: encodeURIComponent(path), ...others }
      const pathHash = path ? ('#' + path) : ''
      const url = subSysBaseUrl + routeUtils.objectToSearchString(urlParams) + pathHash
      console.log(url)
      changeIframeUrl && changeIframeUrl('') // 由于没有使用iframe的唯一key(为了能保留iframe中的历史记录), 在中间设置一次src为空，可以保证能响应每次src变化
      changeIframeUrl && changeIframeUrl(url)
    },
    'ActiveWatcherUpdataLastTime': () => {
      activeWatcher.handleActive()
    }
  })

  const listener = useCallback((event: MessageEvent) => {
    const origin = event.origin
    const source = event.source
    let req = event.data
    if (!source || window == source || !appStore.currentSystemCode) {
      return
    }
    if([PostMessageTypes.GlobalMessageBus].includes(req.type)) {
      return
    }
    if (commands.current[req.type] == null) {
      return console.error('[PostMessage] 错误的 type：', req.type, event)
    }
    let sytemCode = uaaCenter.findSystemCodeByUrl(origin)
    if (!sytemCode) {
      return console.error('[PostMessage] 不合法的 origion：' + origin, event)
    }
    commands.current[req.type](req, source, origin)
  }, [])

  useEffect(() => {
    commands.current['ReFreshAuth'] = commands.current['RefreshToken']
    commands.current['LoginOut'] = commands.current['Logout']

    enable && window.addEventListener('message', listener)
    return () => {
      enable && window.removeEventListener('message', listener)
    }
  }, [])

  return { commands }

}

interface IUseMessageHandlerOptions {
  /**
   * 是否开启 PostMessage 消息监听
   * @default true
   */
  enable?: boolean
  /**
   * 改变 IframeUrl 地址
   */
  onChangeUrl?: (newUrl: string) => void
}

export type MessageHandlers = { [key: string]: (req: IPostMessage, source: MessageEventSource, origin: string) => void }

export { useMessageHandler }